export default [{
    path: '*',
    redirect: {
        path: '/application'
    }
},
    {
        path: '/',
        name: 'HomePage',
        redirect: {
            path: '/application'
        }
    },
    {
        path: '/404',
        name: 'NotFound',
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/errors/NotFound.vue`
                )
    },
    {
        path: '/403',
        name: 'AccessDenied',
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/errors/Deny.vue`
                )
    },
    {
        path: '/500',
        name: 'ServerError',
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/errors/Error.vue`
                )
    },
    {
        path: '/application',
        name: 'OnlineApplication',
        component: () =>
            import (
                `@/views/SelectLanguage.vue`
                )
    },
    {
        path: '/print-application/:apply/:office',
        name: 'PrintApplication',
        component: () =>
            import (
                `@/views/VisaApplicationPrint.vue`
                )
    },
    {
        path: '/arrival-visa-select/:apply/:office',
        name: 'SelectArrivalVisa',
        component: () =>
            import (
                `@/views/arrival/SelectVisa.vue`
                )
    },
    {
        path: '/visa-application/:apply/:office/:type/',
        name: 'VisaApplication',
        props: true,
        component: () =>
            import (
                `@/views/arrival/VisaApplication.vue`
                )
    },
    {
        path: '/visa-application-confirm/:apply/:office',
        name: 'ConfirmApplication',
        props: true,
        component: () =>
            import (
                `@/views/arrival/ArrivalConfirm.vue`
                )
    },
    {
        path: '/visa-application-success',
        name: 'SuccessSaved',
        props: true,
        component: () =>
            import (
                `@/views/ApplicationSuccess.vue`
                )
    },
    {
        path: '/print-form',
        name: 'PrintForm',
        component: () =>
            import (
                `@/views/PrintForm.vue`
                )
    },
]